/* eslint-disable */

const awsmobile = {
  aws_project_region: process.env.REACT_APP_AWS_REGION,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_AWS_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  oauth: {
    domain: process.env.REACT_APP_AWS_OAUTH_DOMAIN,
    scope: [
      'phone',
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin',
    ],
    redirectSignIn:
      'http://localhost:3000/login/loading/,https://enterpret-showcase.vercel.app/login/loading/,https://dev.enterpret.ai/login/loading/,https://dashboard.enterpret.com/login/loading/,https://pre-prod.enterpret.ai/login/loading/',
    redirectSignOut:
      'http://localhost:3000/,https://enterpret-showcase.vercel.app/,https://dev.enterpret.ai/,https://dashboard.enterpret.com/,https://pre-prod.enterpret.ai/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
};

export default awsmobile;
